import React, { Component } from "react";
import styled from "styled-components";
import { connect } from "react-redux";

import Slider from "../../components/Slider";
import Graph from "../../components/graphs/KPIEntityGraph";
import SmallAreaGraph from "../../components/graphs/SmallAreaGraph";
import {
  Main,
  GraphDetailContainer,
  SliderContainer,
  MainArea,
  DetailArea,
  MainText,
  Title,
  Description,
  GraphDescription
} from "../../components/StyledComponents";

class KPIs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isChosen: false
    };
  }
  handleClick = isChosen => {
    this.setState({ isChosen });
  };

  render() {
    const { isChosen } = this.state;
    const { theme } = this.props;
    return (
      <Main>
        <GraphDetailContainer>
          <MainArea>
            <GraphDescription>
              {window.innerWidth < 575
                ? "إختار أي قناة خدمة أو جهة حكومية لمعرفة المزيد"
                : "متوسط اداء الخدمات الحكومية لجميع الجهات الحكومية و علاقته بالقطاعات الاستراتيجية"}
            </GraphDescription>
            <Graph onClick={isChosen => this.handleClick(isChosen)} />
            <SliderContainer>
              <Slider theme={theme} />
            </SliderContainer>
          </MainArea>
          <DetailArea>
            <MainText>دليل مؤشر الخدمات الحكومية</MainText>
            <Title>قنوات تقديم الخدمة</Title>
            <Description>
              هناك حقيقة مثبتة منذ زمن طويل وهي أن المحتوى المقروء لصفحة ما
              سيلهي
            </Description>
            <SmallAreaGraph show={isChosen} />
          </DetailArea>
        </GraphDetailContainer>
      </Main>
    );
  }
}

const mapStateToProps = state => ({
  theme: state.themes.theme
});

export default connect(
  mapStateToProps,
  null
)(KPIs);
